import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useBnsJiaoChengKeShiUpdateQuery, useBnsJiaoChengKeShiUpdateSaveMutation,  } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
import { EditOutlined } from '@ant-design/icons';
function CourseEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bjcks_content:''
    }); 
    const {data,isSuccess} = useBnsJiaoChengKeShiUpdateQuery({bjcks_id:props.bjcks_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bjcks_name:data.Result.bjcks_name,
                    bjcks_content:data.Result.bjcks_content,
                    bjc_name:data.Result.bjc_name,
                })
                setInfo(prevState=>({...prevState,
                    bjcks_name:data.Result.bjcks_name,                        
                    bjcks_content:data.Result.bjcks_content,              
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsJiaoChengKeShiUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined /> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改课时'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bjcks_bjc_id" : props.bjc_id,
                        "bjcks_uid" : localStorage.getItem('eu_id'),
                        "bjcks_uname" : localStorage.getItem('eu_name'),
                        "bjcks_content" : info.bjcks_content,
                        "bjcks_name" : info.bjcks_name, 
                        bjcks_id:props.bjcks_id                           
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    
                    <Form.Item name="bjcks_name" label='课时名称' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bjcks_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item name="bjcks_content" label='备注' wrapperCol={{span:20}}>
                        <MyEditor
                            onChange={(e) => {setInfo(prevState=>({...prevState,bjcks_content:e}))}}
                            height={500}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default CourseEdit